<template>
  <div class="operate-right-top">
    <!-- <a-row
      type="flex"
      justify="start"
      align="middle"
      class="txarea"
    >
      <a-col
        :span="8"
        class="strong comment"
      >
        总评语
      </a-col>
      <a-textarea
        placeholder="请输入评语"
        :rows="4"
        :max-length="maxRemarkLength"
        v-model="remark"
      />
      <p class="count">
        {{ countLength }}/{{ maxRemarkLength }}
      </p>
    </a-row> -->
    <FastComment :link-type-name="linkTypeName" @setRemark="v => remark = v" />
    <div class="audio-wrap">
      <p class="strong audio-title">
        语音点评<span class="operate-tip">
          <a-icon class="tip-icon" type="exclamation-circle" />
          最长{{ maxVideoTime / 60 }}分钟</span>
      </p>
      <AudioRecord ref="audioRecord" :max-video-time="maxVideoTime" @startRecord="startRecord" />
    </div>
    <!-- 是否显示打分 -->
    <template v-if="isShowScore">
      <p class="strong">
        打分
        <!-- <span class="operate-tip" v-if="scoreIndex != null">
          <a-icon class="tip-icon" type="exclamation-circle" />
          分数展示在第{{ scoreIndex + 1 }}页</span> -->
      </p>
      <div class="score-wrap">
        <a-input v-model="score" placeholder="请输入分数" />
        <!-- 输入的有分数才可点 -->
        <a-checkbox class="result-send-checkbox" :disabled="scoreIndex === null" v-model="firstImgScore" @change="firstScore">
          将分数展示在第1页
        </a-checkbox>
      </div>
    </template>
    <!-- 批改结果 -->
    <div v-show="isShowResult">
      <!-- <a-button
        type="primary"
        :ghost="true"
        @click="markScore"
      >
        <i>打分</i>
      </a-button>
      <p style="font-family: 'Score-Num'">
        89.5
      </p> -->
      <a-row
        type="flex"
        justify="start"
        align="middle"
      >
        <a-col
          :span="8"
          class="strong"
        >
          <span class="required">*</span>批改结果
        </a-col>
      </a-row>
      <div class="operate-result">
        <a-tooltip placement="top" :title="item.gold" v-for="item in resultArr" :key="item.key">
          <!-- <template slot="title">
            <span>
              <p>{{ item.gold }}</p>
            </span>
          </template> -->
          <a-button
            type="primary"
            @click="handleAnswerResult(item)"
            :ghost="operateKey !== item.key"
          >
            <i>{{ item.name }}</i>
          </a-button>
        </a-tooltip>
      </div>
      <!-- 只有选择了批改结果才显示发送提醒 -->
      <a-checkbox class="result-send-checkbox" v-if="teacherOperateType" v-model="sendToFamily">
        {{ ModalText }}
      </a-checkbox>
    </div>
  </div>
</template>
<script>
import AudioRecord from '@/components/Audio/AudioRecord.vue'
import FastComment from './FastComment'

export default {
  props: {
    linkTypeName: String,
    // 是否为最后一张图片
    isLastImg: Boolean,
    scoreIndex: Number,
    // 是否显示打分
    isShowScore: Boolean
  },
  components: {
    AudioRecord,
    FastComment
  },
  data() {
    return {
      sendToFamily: false,
      // 最长录音时间, 3分钟，单位秒
      maxVideoTime: 3 * 60,
      // maxRemarkLength: 200,
      // 总评语
      remark: '',
      // 当前批改结果
      curResult: null,
      resultArr: [
        {
          key: 4,
          name: '打回订正',
          gold: '',
          type: 4
        },
        {
          key: 7,
          name: '三星',
          gold: '5-10金币，获得普通树',
          type: 8
        },
        {
          key: 5,
          name: '四星',
          gold: '10-15金币，获得普通树',
          type: 5
        },
        {
          key: 6,
          name: '五星',
          gold: '20-25金币，获得稀有树',
          type: 6
        }
      ],
      // 分数
      score: '',
      // 分数是否展示在第一页
      firstImgScore: false
    }
  },
  computed: {
    // 批改结果类型
    teacherOperateType() {
      const { curResult } = this
      if (!curResult) {
        return 0
      }
      const { type } = curResult
      return type
    },
    operateTypeName() {
      const { curResult } = this
      if (!curResult) {
        return ''
      }
      const { name } = curResult
      return name
    },
    operateKey() {
      const { curResult } = this
      if (!curResult) {
        return ''
      }
      const { key } = curResult
      return key
    },
    // 提醒家长督促学生
    isSupervise() {
      return this.teacherOperateType === 4
    },
    ModalText() {
      return this.isSupervise ? '提醒家长督促学生' : '提醒家长表扬学生'
    },
    // countLength() {
    //   return this.remark.length
    // },
    isRemind() {
      const { sendToFamily } = this
      return sendToFamily ? 1 : 2
    },
    // 是否显示批改结果
    isShowResult() {
      const { isLastImg, teacherOperateType } = this
      return isLastImg || teacherOperateType
    }
  },
  watch: {
    teacherOperateType: {
      immediate: true,
      handler(val) {
        // 只有优秀是默认选中
        this.sendToFamily = val === 6
        this.$emit('isResultChange', val)
      }
    },
    score: {
      immediate: true,
      handler(val, oldVal) {
        this.$nextTick(() => {
          this.markScore(this.score)
        })
        const preVal = oldVal || ''
        // 空
        if (!val) {
          return
        }
        const lastChar = val.charAt(val.length - 1)
        const dot = '.'
        // 最后输入的是点，并且点不在开头，以前里面也不含有点，不验证，直接通过
        if (lastChar === dot && val.indexOf(dot) !== 0 && val.indexOf(dot) === val.lastIndexOf(dot)) {
          return
        }
        // 不能超过三位数，数字后面可以带一位小数点
        const reg = /^\d{1,3}(\.\d{1})?$/
        // 验证不通过，无法输入，负值老的
        if (!reg.test(val)) {
          this.score = preVal
        }
      }
    }
  },
  methods: {
    handleAnswerResult(curResult) {
      this.curResult = curResult
      this.$emit('resultChange', curResult)
    },
    scoreChange(event) {
      const { data, target } = event
      console.log(data, target.value)
      //
    },
    /**
     * 分数展示在第一页
     */
    firstScore() {
      this.markScore(this.score, true)
      this.$emit('firstScoreClick', this.firstImgScore)
    },
    /**
     * 打分
     * isFirst 是否将分数打到第一页
     */
    markScore(score, firstCheckbox) {
      this.$nextTick(() => {
        this.$emit('markScore', score, this.firstImgScore, firstCheckbox)
      })
    },
    startRecord(e) {
      //
    },
    /**
     * 获取录音信息
     */
    async getRecord(uploadKeys, audioName) {
      const audioRecordRef = this.$refs.audioRecord
      // 录音了
      if (audioRecordRef.recordTime) {
        if (audioRecordRef.isRecording) {
          // 正在录音中
          return {
            errorMsg: '正在录音中，请先停止录音'
          }
        }
        const { signMap } = await uploadKeys.getResult()
        const { url, audioDuration } = await audioRecordRef.upload([signMap.get(audioName)], audioName)
        return {
          audioUrl: url,
          audioDuration
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.strong {
  font-weight: bold;
}
.audio-wrap {
  border: 1px solid #EBEDF0;
  border-left: none;
  border-right: none;
  margin: 0 -22px 20px -22px;
  padding: 20px 22px 0 22px;
}
.audio-title {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 9px;
}
.operate-tip {
  color: #98A2B2;
  font-weight: normal;
  font-size: 12px;
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
  .tip-icon {
    margin-right: 4px;
  }
}
// .txarea {
//   position: relative;
//   margin-bottom: 20px;
//   .ant-input {
//     color: #505873;
//     margin-top: 5px;
//     border-radius: 6px;
//     height: 104px;
//   }
//   .count {
//     position: absolute;
//     right: 14px;
//     bottom: 6px;
//     color: #98a2b2;
//     font-size: 12px;
//   }
// }
.required {
  color: #f00;
  vertical-align: middle;
  font-weight: normal;
  margin-left: -6px;
}
.score-wrap {
  margin: 9px 0 20px 0;
}
// 批改结果
.operate-result {
  display: flex;
  margin-top: 9px;
  :deep(.ant-btn) {
    padding: 0 12px;
    margin-right: 13px;
    &:last-child {
      margin-right: 0;
    }
    i {
      letter-spacing: normal !important;
      margin-right: 0 !important;
    };
  }
}
</style>